module.exports = __webpack_public_path__ + "img/ai_help01_img_07.b4f2f91c.png";